// Which technologies Gundi actually needs an address for. Everything else has a
// fixed endpoint baked into its connector, so a URL there is an optional
// override — offered, never demanded.
//
// Keyed by the integration type's `value` (the slug), not its display name, and
// shared by every screen that asks for an address — the Route wizard, the
// Connection page and modal, and the flow map's General pane — so they cannot
// disagree about who needs one. (They did: the destination screens used to key a
// separate hand-maintained list off the display NAME, which made a URL required
// for every technology nobody had thought to exempt.)
export const TYPES_WITH_REQUIRED_BASE_URL = [
  'earth_ranger',
  'cellstop',
  'mella_tracking',
  'smart_connect',
];

export const baseUrlIsRequired = (typeValue?: string): boolean =>
  !!typeValue && TYPES_WITH_REQUIRED_BASE_URL.includes(typeValue);

// Kept for the provider-side call sites, which read the same rule.
export const PROVIDER_TYPES_WITH_BASE_URL = TYPES_WITH_REQUIRED_BASE_URL;
export const providerNeedsBaseUrl = baseUrlIsRequired;
